import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { LinearProgress } from 'components/shared/Progress';
import styles from './AcquisitionStatusProgress.module.css';

function AcquisitionStatusProgress() {
  const rasterStatus = useSelector((state) => state.data.commissioningGA2.rasterStatus);
  const value = rasterStatus?.customStatus?.status_info?.progress ?? 0;
  // initial progress value 0 has different format than value in progress 
  const validProgressValue = typeof value === 'number' ? value : (value?.progress ?? 0);
  const numberFormatter = useMemo(
    () => new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 0 }),
    []
  );

  return (
    <div className={styles.root}>
      <div className={styles.progress}>
        <div className={styles.progressBar}>
          <LinearProgress value={value} />
        </div>
        <div className={styles.progressValue}>{numberFormatter.format(validProgressValue / 100)}</div>
      </div>
      <div className={styles.status}>
        {rasterStatus?.customStatus?.status === 'completed'
          ? 'Raster is completed'
          : 'Raster could take several minutes'}
      </div>
    </div>
  );
}

export default AcquisitionStatusProgress;
